app.controller(
    'IndexController', ['$scope', AppController]
);

function IndexController($scope) {

}
